import { createColorKey } from './utils';
import { ElementSelect } from './elementSelect';
export function ElementSelectByColor(options) {
    return ElementSelect(Object.assign(Object.assign({}, options), { createGroup: createColorKey }));
}
ElementSelectByColor.props = {
    reapplyWhenUpdate: true,
};
//# sourceMappingURL=elementSelectByColor.js.map